export var USER_ARI_PREFIX = 'ari:cloud:identity::user/';
export var getAAIDFromARI = function getAAIDFromARI(ari) {
  return ari.replace(USER_ARI_PREFIX, '');
};